import { useEffect, useState } from "react";
import "reactjs-popup/dist/index.css";
import Swal from "sweetalert2";
import { ReactComponent as Delete } from "../../assets/images/svg/Delete.svg";
import SchedulePopUp from "../../Popups/SchedulePopup";
import ScheduleTemplatePopup from "../../Popups/ScheduleTemplatePopup";
import { ReactComponent as Edit } from "../../assets/images/svg/Edit.svg";
import axios from "axios";
import useAuth from "../../hooks/useAuth";
import UseAxiosPrivate from "../../hooks/useAxiosPrivate";


function ScheduleTime(props) {
  const handleChange = (e) => {
    props.setData((oldArray) => {
      return { ...oldArray, schedule_time: e.target.value };
    });
  };

  const sendScheduleTimeToNewCampaign = () => {
    if (props.scheduleTime !== "") {
      props.setActive(props.next);
    } else {
      Swal.fire({
        icon: "error",
        title: "Campaign Creation Failed",
        text: "Please select a Schedule Time for the campaign.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
      })
      return;
    }
  };

  const [isScheduleOpen, setIsScheduleOpen] = useState(false);
  const [isScheduleTemplateOpen, setIsScheduleTemplateOpen] = useState(false);

  const AddSchedule = () => {
    setIsScheduleOpen(true);
  }

  const AddScheduleTemplate = () => {
    setIsScheduleTemplateOpen(true);
  }


  const handleDelete = async (index, id) => {
      
    Swal.fire({
        title: "Are you sure to Delete ?",
        text: "This Schedule will be deleted from your schedule list",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete",
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (id != null) {
            let config = {
              headers: { "Content-Type": "application/json" },
              data: {
                "schedule_id": id,
              }
            };

            await axios
              .delete(
                process.env.REACT_APP_API_URL + "/contactcentre/delete-schedule/",
                config
              )
              .then((res) => {
                Swal.fire(
                  'Deleted!',
                  'Customer has been deleted.',
                  'success'
                );
              })
            }

            props.setData(prev => ({
              ...prev,
              schedule_time: prev.schedule_time.filter(
                (_, i) => i !== index
              )
            }));
            
          
        }
      })
  };

  // const handleScheduleToggle = (e) => {
  //   setIsScheduleOpen(e.target.checked);
  // };

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const [showMenu, setShowMenu] = useState(false);

  const [schedulelist, setScheduleList] = useState([]);

  const filteredOptions = schedulelist.filter(option =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setShowMenu(true);
  };

  const [schedList, setSchedList] = useState("");

  const handleOptionSelect = async(option) => {
    // alert(option.id)
    setSelectedOption(option);
    setSearchTerm(option.name); // Show selected label in input
    setShowMenu(false); // Hide menu after selection
    props.setScheduledTimeChanged(true);

    try{
      const res = await axiosprivate.get(`${process.env.REACT_APP_API_URL}/contactcentre/shedule_time_template_schedules/${option.id}`)
      
      if(res.status===200){
        // alert("success")
        // console.log(JSON.stringify(res.data))
        setSchedList(res.data)
        // props.setData(old => ({
        //     ...old,
        //     schedule_time: [
        //         ...(old.schedule_time || []),
        //         ...res.data.map(({id,...rest})=>rest)
        //     ]
        // }));
        props.setData(old => ({
            ...old,
            schedule_time: res.data.map(({id,...rest})=>rest)
        }));
        setSearchTerm('');
      }

    }catch(error){
      // alert(1)
      // alert(JSON.stringify(error))
      setSearchTerm('');
      Swal.fire(
        'Warning!',
        `${error.response.data?.error || 'Something Went wrong. Try Again.'}`,
        'warning'
      );
    }

    
  };

  const toggleMenu = () => {
    if(filteredOptions.length <= 0){
      Swal.fire(
        'Warning!',
        `Currently, no schedule template is available. Click ‘Open Schedule Template’ to create one.`,
        'warning'
      );
      return;
    }
    setShowMenu(!showMenu);
  };

  const handleBlur = () => {
    // Delay hiding menu to allow option selection
    setTimeout(() => setShowMenu(false), 150);
  };


  const axiosprivate = UseAxiosPrivate();
  const user = useAuth()
  const user_id = user.auth.user_details.id;

  const fetchScheduleTimeTeamplates=async()=>{
      try{
          const res = await axiosprivate.get(`${process.env.REACT_APP_API_URL}/contactcentre/shedule_time_template/`)
          
          if(res.status==200){
            setScheduleList(res.data)
            // alert(res.data)
          }
        }catch(error){
          Swal.fire(
            'Warning!',
            `${error.response.data?.error || 'Something Went wrong. Try Again.'}`,
            'warning'
          );

      }
  }

  useEffect(()=>{
    fetchScheduleTimeTeamplates();
  },[])


  return (
    <div className="max-w-5xl p-6 ml-5">
      <SchedulePopUp
        isOpen={isScheduleOpen}
        onClose={() => setIsScheduleOpen(false)}
        setData={props.setData}
        scheduleTime={props?.scheduleTime}
      />

      <ScheduleTemplatePopup
        isTempOpen={isScheduleTemplateOpen}
        onClose={() => setIsScheduleTemplateOpen(false)}
        setData={props.setData}
        scheduleTime={props?.scheduleTime}
        schedList={schedList}
        setSchedList={setSchedList}
        schedulelist={schedulelist}
        setScheduleList={setScheduleList}
      />



      <p className="text-sm text-slate-400">Step 3/7</p>
      <h1 className="text-lg font-bold">Let's Schedule Time</h1>
      <p className="text-sm text-slate-400 border-b-2 pb-8">
        Please schedule time, so that we can create new campaign
      </p>

      <div className="flex items-center gap-4 pt-8">
        <span className="text-sm text-slate-400 font-medium">Schedule Campaign :</span>
        <button
          type="button"
          onClick={AddSchedule}
          className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition duration-200"
        >
          Open Schedule
        </button>

            <span className="text-sm text-slate-400 font-medium">Schedule Template :</span>
            <div className="relative">
              {/* Searchable Input */}
              <input
                type="text"
                value={searchTerm}
                onChange={handleInputChange}
                onClick={toggleMenu}
                onBlur={handleBlur}
                placeholder="Select Schedule Template"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-80 pl-10 p-2 "
              />
              <div className="absolute left-[0.35rem] right-[0rem] top-[0.5rem] z-10 w-[1.4rem] h-[1.4rem]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#00000051"
                  strokeWidth={2.5}
                >
                  <circle cx="12" cy="13" r="8" />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v4l3 2M9 3h6"
                  />
                </svg>
              </div>

              {/* Dropdown Menu */}
              {showMenu && (
                <ul
                  className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-10"
                  onMouseDown={(e) => e.preventDefault()} // Prevent input blur when interacting with dropdown
                >
                  {filteredOptions.map((option) => (
                    <li
                      key={option.value}
                      onClick={() => handleOptionSelect(option)} // Handle option selection
                      className="cursor-pointer py-2 px-4 hover:bg-gray-200"
                    >
                      {option.name}
                    </li>
                  ))}
                  {filteredOptions.length === 0 && (
                    <li className="py-2 px-4 text-gray-500">No options found</li>
                  )}
                </ul>
              )}
            </div>
            
            <button
              type="button"
              onClick={AddScheduleTemplate}
              className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition duration-200"
            >
              Open Schedule Template
            </button>
      </div>

      {/* Schedule Table */}
      <div>
        <div className="relative overflow-x-auto mt-12">
          <table className="min-w-full text-sm text-left">
            <thead className="bg-gray-50 border-b">
              <tr>
                {/* <th className="px-6 py-4 font-medium text-gray-700">#</th> */}
                <th className="px-6 py-4 font-medium text-gray-700">Schedule Type</th>
                <th className="px-6 py-4 font-medium text-gray-700">Start Date</th>
                <th className="px-6 py-4 font-medium text-gray-700">Start Time</th>
                <th className="px-6 py-4 font-medium text-gray-700">End Date</th>
                <th className="px-6 py-4 font-medium text-gray-700">End Time</th>
                <th className="px-6 py-4 font-medium text-gray-700">Days</th>
                <th className="px-6 py-4 font-medium text-gray-700">Action</th>
              </tr>
            </thead>
            <tbody>
              {props.scheduleTime.map((obj, index) => (
                <tr key={obj.id ?? `temp-${index}`} className="border-b hover:bg-gray-50 transition-colors">
                  {/* <td className="px-6 py-4 text-gray-700 font-mono">{obj?.id}</td> */}
                  <td className="px-6 py-4 text-gray-700 font-mono">
                    {obj.schedule_type}
                  </td>
                  <td className="px-6 py-4 text-gray-700 font-mono">
                    {obj.start_date}
                  </td>
                  <td className="px-6 py-4 text-gray-700 font-mono">
                    {new Date(`1970-01-01T${obj.start_time}`).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </td>
                  <td className="px-6 py-4 text-gray-700 font-mono">
                    {obj.end_date}
                  </td>
                  <td className="px-6 py-4 text-gray-700 font-mono">
                    {new Date(`1970-01-01T${obj.end_time}`).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </td>
                  <td className="px-6 py-4 text-gray-700 font-mono">
                    {obj.recurring_days}
                  </td>
                  <td className="px-6 py-4 flex space-x-2">
                    <button
                      onClick={() => handleDelete(index, obj.id)}
                      className="inline-flex items-center justify-center w-8 h-8 rounded-full text-red-500 hover:bg-red-50 hover:text-red-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-red-200"
                      aria-label={`Delete schedule ${obj}`}
                      title="Delete schedule"
                    >
                      <Delete
                        className="w-4 h-4"
                        fill="#b30000ff"
                        style={{ color: '#b30000ff' }}
                      />
                    </button>
                    {/* <div className="flex  rounded-md p-2 cursor-pointer hover:bg-light-white text-gray-300 text-sm items-center gap-x-4">
                      <Edit
                        className={`width="26" height="26" fill="blue"`}
                        viewBox="0 0 26 26"
                        fill="green"
                        cx="8.5"
                        cy="8.5"
                        r="6"
                        fillRule="evenodd"
                        fillOpacity=".8"
                      />
                    </div> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="pt-8 flex justify-between items-between">
        <button
          className="px-8 py-3 font-semibold text-gray-600 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
          onClick={() => {
            props.setActive(props.back);
          }}
        >
          Back
        </button>
        <button
          className="font-bold text-lg rounded-full w-36 h-12"
          style={{
            backgroundImage:
              "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
            color: "white",
          }}
          onClick={sendScheduleTimeToNewCampaign}
        >
          Next Step
        </button>
      </div>
    </div>
  );
}
export default ScheduleTime;
